/**
 * @desc byList
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsChannelResponseDto>>;
export function request(
  body: defs.tms.LogisticsChannelRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logistics/channel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
